var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spk-object md-layout md-alignment-center-left md-dense"},[_c('div',{staticClass:"md-layout-item spk-object-id"},[_vm._v(_vm._s(_vm.spkobj._id))]),_vm._v(" "),_c('div',{staticClass:"md-layout-item"},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.select(_vm.spkobj._id)}}},[_c('md-icon',[_vm._v("zoom_in")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8855c12","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpeckleReceiverObject.vue
// module id = 463
// module chunks = 0